export default __webpack_public_path__ + "static/media/failed.c94867ad.png";